import { render, staticRenderFns } from "./MediaLibrarySettings.vue?vue&type=template&id=042806a2"
import script from "./MediaLibrarySettings.vue?vue&type=script&lang=js"
export * from "./MediaLibrarySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports